// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_1id8t","locked":"index_locked_1vSrS"};